import { nameWithoutBlacklistedWordsPattern } from '../validation'

export const validateNameWithoutBlacklistedWords = (value: string) =>
  nameWithoutBlacklistedWordsPattern.test(value.toLowerCase())
